// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"774155da","732":"f5594336","977":"0a1d3795"}[chunkId] + ".chunk.js";
};